module.exports = __webpack_public_path__ + "img/UnionPay.51456b79.png";